import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { useReturn } from "util/return";
import { useSetTitle } from "util/title";

import { Container, Message, Button } from "react-bulma-components";

import EditAffiliationStatus from "./edit";
import { usePreloadInstitutionOptions } from "./institution";
import { profileSlice } from "redux/features/profile";
import RegistrationProgress from "../participation/registrationProgress";

export function EditCurrentAffiliation({ mainUrl }) {
  useSetTitle("Current Affiliation/Occupation");
  const institutionOptions = usePreloadInstitutionOptions();

  const doClose = useReturn();
  const { registrationPending } = useSelector(profileSlice.selector);

  if (!institutionOptions.loaded)
    return (
      <Container className="spaced">
        Loading data from server; please wait.
      </Container>
    );

  return (
    <Container className="spaced">
      {registrationPending ? (
        <Fragment>
          <RegistrationProgress returnOnCancel />
          <EditAffiliationStatus
            dateSpecifier="indefinite-future"
            forRegistration={registrationPending}
          />
        </Fragment>
      ) : (
        <Message>
          <Message.Header>
            Current Affiliation/Occupation
            <Button remove onClick={doClose} />
          </Message.Header>
          <Message.Body className="basic-edit-affiliation">
            <EditAffiliationStatus dateSpecifier="indefinite-future" />
          </Message.Body>
        </Message>
      )}
    </Container>
  );
}

export default EditCurrentAffiliation;
